// extracted by mini-css-extract-plugin
export var active = "dashboard-navigation-module--active--ac01d";
export var bar = "dashboard-navigation-module--bar--6a6ba";
export var barButton = "dashboard-navigation-module--bar-button--65c0d";
export var barButtonBox = "dashboard-navigation-module--bar-button-box--06775";
export var barButtonChevron = "dashboard-navigation-module--bar-button-chevron--5091c";
export var barButtonDots = "dashboard-navigation-module--bar-button-dots--831fb";
export var barDropdown = "dashboard-navigation-module--bar-dropdown--a0d78";
export var barItem = "dashboard-navigation-module--bar-item--44a01";
export var barOpen = "dashboard-navigation-module--bar-open--06f34";
export var barVisibleBox = "dashboard-navigation-module--bar-visible-box--a4866";
export var container = "dashboard-navigation-module--container--2b1f6";
export var link = "dashboard-navigation-module--link--3a70a";
export var linkContent = "dashboard-navigation-module--link-content--8b25f";